import React, { useState } from "react";
import userLogo from "../assets/user.png";
import { IoMailSharp, IoListOutline } from "react-icons/io5";
import { RiAlertFill } from "react-icons/ri";
import { LuLogOut } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import useAuth from "../useAuth";
import { motion } from "framer-motion";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    logout();
  };

  return (
    <motion.div
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="flex items-center sticky top-0 z-50 justify-between px-6 py-4 backdrop-blur-lg border-b border-gray-200 bg-white/70 rounded-b-xl shadow-sm"
    >
      {/* Left Section */}
      <div className="flex items-center gap-4">
        <img
          src={userLogo}
          alt="User"
          className="w-10 h-10 rounded-full object-cover select-none border-2 border-gray-300"
        />
        <div className="text-base font-medium text-gray-800 select-none">
          {user?.fullName}
        </div>
      </div>

      {/* Center Actions */}
      <div className="flex items-center gap-12">
        <div className="flex items-center gap-6 text-gray-600 text-2xl">
          <IconWithBadge icon={<IoMailSharp />} count={2} />
          <IconWithBadge icon={<RiAlertFill />} count={1} />
          <IconWithBadge icon={<IoListOutline />} />
        </div>

        {/* Right Logout */}
        <div
          className="flex items-center gap-3 cursor-pointer text-gray-800 text-sm font-medium hover:text-gray-900 transition"
          onClick={handleLogout}
        >
          <span>Log out</span>
          <LuLogOut className="text-lg" />
        </div>
      </div>
    </motion.div>
  );
}

// Icon button with optional badge
const IconWithBadge = ({ icon, count = 0 }) => (
  <div className="relative cursor-pointer hover:text-gray-800 transition">
    {icon}
    {count > 0 && (
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full shadow"
      >
        {count}
      </motion.div>
    )}
  </div>
);
